import { Box, Container } from "@mui/material";
import { BreadcrumbsNavbar } from "components";

export function BasePage({
 children,
 showBreadcrumbs = false,
 breadcrumbProps = {},
}) {
 return (
  <Box component="main" sx={{ flexGrow: 1 }}>
   {showBreadcrumbs && <BreadcrumbsNavbar {...breadcrumbProps} />}

   <Container
    sx={{
     pt: showBreadcrumbs ? "48px" : "16px",
    }}
   >
    {children}
   </Container>
  </Box>
 );
}

export function BasePageWithStickyHeader({
 children,
 stickyHeader,
 containerProps = {},
}) {
 return (
  <Box component="main" sx={{ flexGrow: 1 }}>
   {stickyHeader}

   <Container {...containerProps}>{children}</Container>
  </Box>
 );
}
